import { User } from '.';
import { Nullable } from '../types';

export type TSalesCommissionId = number;

export interface SalesCommission {
  id: TSalesCommissionId;
  user: User;
  user_id: number;
  reporting_quarter_id: number;
  payment_structure: string;
  start_date: string;
  end_date: string | null;
  start_reporting_quarter: string;
  end_reporting_quarter?: Nullable<string>;
  percent_rate: string;
  comments?: Nullable<string>;
  created_at?: string;
  updated_at?: string;
}
